import { RadioTower } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import type { TradeIdeasScanner } from "@/lib/tradeideas/types";
import { cn } from "@/lib/utils";

export function ScannerList({
  scanners,
  selectedId,
  onSelect,
}: {
  scanners: TradeIdeasScanner[];
  selectedId: string | null;
  onSelect: (scannerId: string) => void;
}) {
  return (
    <aside className="overflow-hidden rounded-md border border-border">
      <div className="border-b border-border bg-muted/30 px-3 py-2 text-xs font-medium uppercase tracking-wider text-muted-fg">
        Scanners
      </div>
      <div className="max-h-[calc(100vh-230px)] overflow-auto">
        {scanners.map((scanner) => (
          <button
            key={scanner.id}
            type="button"
            onClick={() => onSelect(scanner.id)}
            className={cn(
              "flex w-full items-start gap-3 border-b border-border/60 px-3 py-3 text-left last:border-b-0 hover:bg-muted/20",
              selectedId === scanner.id && "bg-muted/30",
            )}
          >
            <RadioTower className="mt-0.5 size-4 shrink-0 text-muted-fg" />
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-medium">{scanner.name}</span>
              <span className="block truncate font-mono text-[11px] text-muted-fg">
                {scanner.id}
              </span>
              <span className="mt-1 flex flex-wrap gap-1">
                <Badge variant={scanner.enabled ? "success" : "outline"}>
                  {scanner.enabled ? "enabled" : "disabled"}
                </Badge>
                <Badge variant="outline">{scanner.scanner_type}</Badge>
              </span>
            </span>
          </button>
        ))}
      </div>
    </aside>
  );
}
